import type {StyleRuleObject} from "../../../../../../stem-core/ui/Style";
import {UI} from "../../../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/ui/Style";
import {styleRule, styleRuleInherit} from "../../../../../../stem-core/decorators/Style";
import {Messages} from "../../../../../Messages.js";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {iFrameState} from "../../../../../services/IFrameState.js";
import {CheckboxInput} from "../../../../../../stem-core/ui/input/checkbox/CheckboxInput.jsx";
import {Flow} from "../../../../flows/Flow.js";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService.js";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {BasePanelPageStyle} from "../../../../PanelPage.jsx";
import {AmountRadioButtonsInput} from "../../../../../../core/ui/input/radio/AmountRadioButtonsInput.jsx";
import {RadioButtonsInput, RadioButtonsInputStyle} from "../../../../../../core/ui/input/radio/RadioButtonsInput.jsx";


class DonationAmountAndFrequencyStyle extends StyleSheet {
    @styleRule
    coverFeesCheckbox = {
        marginTop: 12,
        marginBottom: 12,
        color: this.themeProps.TEXT_SECONDARY_COLOR + " !important",
    };
}

class FrequenciesRadioButtonInputStyle extends RadioButtonsInputStyle {
    @styleRuleInherit
    container: StyleRuleObject = {
        gap: "10px",
        ">:first-child": null,
        ">:last-child": null,
    }

    @styleRuleInherit
    button = {
        borderRadius: this.themeProps.RADIO_BUTTON_BORDER_RADIUS,
    }
}

interface DonationAmountAndFrequencyOptions {
    onChange?: () => void;
}

@autoredraw(iFrameUserDataService)
@registerStyle(DonationAmountAndFrequencyStyle)
export class DonationAmountAndFrequency extends UI.Element<DonationAmountAndFrequencyOptions> {
    // TODO @branch the other components should listen for changes to Flow.donationDetails
    updateDonationDetails(options: Record<string, any>) {
        Flow.donationDetails.update(options);
        this.dispatchChange();
    }

    render() {
        const {styleSheet} = this;
        const panelStyleSheet = BasePanelPageStyle.getInstance(this.getTheme());

        const {
            minAmount,
            maxAmount,
            frequencyOptions,
            predefinedAmounts,
            currency,
        } = Flow.donationDetails.getOptionsForDonor();

        // TODO @flow It looks like we can't edit the frequency of a donation
        const showFrequencies = frequencyOptions.length > 1;

        return [
            <div className={panelStyleSheet.title}>
                {Messages.donationDetails}
            </div>,

            <AmountRadioButtonsInput
                currency={currency}
                amounts={predefinedAmounts}
                initialValue={Flow.donationDetails.donationAmount}
                onChange={(donationAmount) => this.updateDonationDetails({donationAmount})}
                customAmountOptions={{
                    minAmount: minAmount,
                    maxAmount: maxAmount,
                }}
            />,

            iFrameState.allowUserToCoverFees && <CheckboxInput
                ref="payDonationFeeCheckbox"
                label={Messages.donorCoversFeesCheckbox(Flow.donationDetails.getDonationFee())}
                className={styleSheet.coverFeesCheckbox}
                initialValue={Flow.donationDetails.donorCoversFees}
                onChange={(donorCoversFees) => this.updateDonationDetails({donorCoversFees})}
            />,

            <MessageElement message={Messages.donationExplanationMessage}/>,

            showFrequencies && <RadioButtonsInput
                styleSheet={FrequenciesRadioButtonInputStyle}
                values={frequencyOptions}
                formatter={(frequency) => frequency.getFrequencyName()}
                initialValue={Flow.donationDetails.frequency}
                onChange={(frequency) => this.updateDonationDetails({frequency})}
            />,
        ];
    }
}
